export default __webpack_public_path__ + "static/media/meteors-login.0e345389.png";